import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ExampleView } from '../../views';

export const exerciseData14: ExerciseData = {
    ExerciseView: Module1Exercise4,
    dataKeys: [],
    questions: [],
};

function Module1Exercise4({ exercise }: ExerciseViewProps) {
    return (
        <ExampleView
            exercise={exercise}
            body={[
                'Jeg føler mig ofte overvældet af alt det, jeg skal nå i løbet af en dag. Mit arbejde kræver meget tid og energi. Det er som om at uanset hvor hurtigt jeg løber, eller prøver at optimere det jeg skal, så er jeg aldrig rigtig on top. Det føles som om, jeg aldrig har tid til bare at slappe af eller tage en pause. Jeg kan mærke, at det begynder at sætte sig hos mig – jeg sover dårligt, og jeg føler mig konstant træt og udkørt.',
                'Det værste er, at jeg ikke tør sige det til nogen. Jeg vil ikke have, at folk ser mig som en, der ikke kan klare det, så jeg holder det for mig selv. Jeg prøver at lade som om, alt er fint, men indeni føles det som om, jeg er ved at miste grebet. Jeg ved ikke, hvor længe jeg kan blive ved på den her måde.',
            ]}
        />
    );
}
